import { render } from "./RecipeCard.vue?vue&type=template&id=1b98ef2b&scoped=true"
import script from "./RecipeCard.vue?vue&type=script&lang=js"
export * from "./RecipeCard.vue?vue&type=script&lang=js"

import "./RecipeCard.vue?vue&type=style&index=0&id=1b98ef2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b98ef2b"]])

export default __exports__